export const sumArrayValues = (array: Array<number>): number =>
  array.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

export const notificationTypes = [
  { name: 'on_order_day', label: "On Order's day" },
  { name: 'on_order_start', label: 'On Order start' },
  { name: 'on_order_arriving_interval', label: 'On Order arriving interval' },
];
